// extracted by mini-css-extract-plugin
module.exports = {"content":"diseaseSetPage_content__3uq7M","queryWrap":"diseaseSetPage_queryWrap__1cSOc","tableWrap":"diseaseSetPage_tableWrap__2D900"};